import { Badge, Box, Button, HStack, Spacer, Text, VStack } from '@chakra-ui/react'
import parse from 'html-react-parser'
import InfiniteScroll from 'react-infinite-scroll-component'
import { FunctionComponent, useState } from 'react'
import Card from '../../common/components/Card'
import { ProductResult } from './ScriptForm/ProductSearchContextSlice'

interface SearchResultsProps {
  results: ProductResult[]
  onAdd: (result: ProductResult) => any
  onSelect: (result: ProductResult) => any
  selectedId?: string
  hasMore: boolean
  loadMoreResults: () => any
  selectionDisabled?: boolean
}

export const DrugSearchResultsPanel: FunctionComponent<SearchResultsProps> = ({
  results,
  onAdd,
  onSelect,
  selectedId,
  loadMoreResults,
  hasMore,
  selectionDisabled = false,
}) => {
  return (
    <Card height="300px" overflow="auto">
      <VStack align="stretch" spacing="0" id="scrollableDiv" height="100%" overflow="auto">
        <InfiniteScroll
          scrollableTarget="scrollableDiv"
          dataLength={results?.length ?? 0}
          next={loadMoreResults}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
        >
          {results?.map((result) => (
            <SearchResult
              result={result}
              onAdd={onAdd}
              onSelect={onSelect}
              key={result.productId}
              selected={selectedId === result.productId}
              disabled={selectionDisabled}
            />
          ))}
        </InfiniteScroll>
      </VStack>
    </Card>
  )
}

interface SearchResultProps {
  result: ProductResult
  onAdd: (result: ProductResult) => any
  onSelect: (result: ProductResult) => any
  selected: boolean
  disabled: boolean
}

const SearchResult: FunctionComponent<SearchResultProps> = ({
  result,
  onAdd,
  onSelect,
  selected,
  disabled,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const handleAdd = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setIsLoading(true)
    await onAdd(result)
    setIsLoading(false)
  }
  return (
    <Box
      p="3"
      borderBottom="1px solid gray"
      borderBottomColor="gray.200"
      transition="background-color 0.3s"
      bgColor={selected ? 'gray.200' : 'white'}
      _hover={{
        bgColor: 'gray.100',
      }}
      className="drug_search_result"
    >
      <HStack justifyContent="space-between">
        <Text>
          {parse(result.productName)}
          <Spacer />
          {result.productType === 'branded' ? (
            <Badge variant="solid" colorScheme="orange">
              branded
            </Badge>
          ) : (
            <Badge variant="solid" colorScheme="green">
              generic
            </Badge>
          )}
        </Text>
        <HStack>
          <Button
            colorScheme="blue"
            size="sm"
            onClick={handleAdd}
            isLoading={isLoading}
            disabled={isLoading || disabled}
          >
            Select
          </Button>
          <Button
            aria-label={`View details for ${result.productName}`}
            disabled={disabled}
            onClick={() => onSelect(result)}
            size="sm"
            variant="outline"
          >
            Details
          </Button>
        </HStack>
      </HStack>
    </Box>
  )
}
